var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"bounce"}},[_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.isVisible),expression:"isVisible"}],staticClass:"back-to-top",on:{"click":_vm.scrollToTop}},[_c('van-icon',{attrs:{"name":"arrow-up","size":"20px"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }